import { ref } from 'vue'

const STORAGE_KEY = 'portal.mall.recentSearches'
const MAX = 8

function load(): string[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return []
    const parsed = JSON.parse(raw)
    return Array.isArray(parsed)
      ? parsed.filter((v): v is string => typeof v === 'string' && v.trim()).slice(0, MAX)
      : []
  } catch {
    return []
  }
}

const recentSearches = ref<string[]>(load())

function persist() {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(recentSearches.value))
  } catch {
    /* ignore */
  }
}

export function useRecentSearches() {
  const pushSearch = (keyword: string) => {
    const q = keyword.trim()
    if (!q) return
    recentSearches.value = [q, ...recentSearches.value.filter((item) => item !== q)].slice(0, MAX)
    persist()
  }

  const removeSearch = (keyword: string) => {
    recentSearches.value = recentSearches.value.filter((item) => item !== keyword)
    persist()
  }

  const clearSearches = () => {
    recentSearches.value = []
    persist()
  }

  return { recentSearches, pushSearch, removeSearch, clearSearches }
}
